import QuickAddClient from "../../components/ui/QuickAddClient";
import OptionalSection from "../../components/ui/OptionalSection";
import { useRef as useSaveRef } from "react";
import { Snackbar } from "@material-ui/core";
import update from "immutability-helper";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { Alert } from "@material-ui/lab";
import React from "react";
import $ from "jquery";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Check from "@material-ui/icons/Check";
import SettingsIcon from "@material-ui/icons/Settings";

import PurchaseService from "../../services/PurchaseOrder";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import ManufacturingBatchService from "../../services/ManufacturingBatchService";
import CurrencyService from "../../services/CurrencyService";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import UtilsFormule from "../../utils/UtilsFormule";
import { Link, useNavigate } from "react-router-dom";
import RateService from "../../services/RateService";
import WarehouseService from "../../services/WarehouseService";
import Societe from "../../services/Societe";
import SellingService from "../../services/SellingService";
import StockOfProductSale from "./StockOfProductSale";
import withLoader from "../../components/layouts/WithLoader";
import AddPackFactureModel from "./AddPackFactureModel";

const useQontoStepIconStyles = makeStyles({
  root: {
    color: "#eaeaf0",
    display: "flex",
    height: 22,
    alignItems: "center",
  },
  active: {
    color: "#000000",
  },
  circle: {
    width: 8,
    height: 8,
    color: "#fff",
    borderRadius: "50%",
    backgroundColor: "#000000",
  },
  completed: {
    color: "#000000",
    zIndex: 1,
    fontSize: 18,
  },
});

function QontoStepIcon(props) {
  const classes = useQontoStepIconStyles();
  const { active, completed } = props;

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
      })}
    >
      {completed ? (
        <Check className={classes.completed} />
      ) : (
        <div className={classes.circle} />
      )}
    </div>
  );
}

QontoStepIcon.propTypes = {
  active: PropTypes.bool,

  completed: PropTypes.bool,
};

const useColorlibStepIconStyles = makeStyles({
  root: {
    "& .MuiStepIcon-root.MuiStepIcon-active ": {
      backgroundColor: "#ccc",
      zIndex: 1,
      color: "#000",
      width: 50,
      height: 50,
      display: "flex",
      borderRadius: "50%",
      justifyContent: "center",
      alignItems: "center",
    },
  },
  active: {
    "& .MuiStepIcon-root.MuiStepIcon-active ": {
      color: "#000000",
    },
  },
  completed: {
    "& .MuiStepIcon-root.MuiStepIcon-completed": {
      color: "#000000",
    },
  },
});

function ColorlibStepIcon(props) {
  const classes = useColorlibStepIconStyles();
  const { active, completed } = props;

  const icons = {
    1: <SettingsIcon />,
  };

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
        [classes.completed]: completed,
      })}
    >
      {icons[String(props.icon)]}
    </div>
  );
}

ColorlibStepIcon.propTypes = {
  active: PropTypes.bool,

  completed: PropTypes.bool,

  icon: PropTypes.node,
};

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiStepIcon-root.MuiStepIcon-active ": {
      width: "100%",
      color: "#000000",
    },
    "& .MuiStepIcon-root.MuiStepIcon-completed": {
      color: "#000000",
    },
  },
  button: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  icon: {
    color: "#000",
  },
}));
const styles = {
  container: (base) => ({
    ...base,
    flex: 1,
  }),
};
function getSteps() {
  return [
    "Inscrivez le bon de commande  ou les produits ",
    "Créer un facture  ",
    "Finaliser",
  ];
}

const AddFactureSell = ({ startLoading, stopLoading }) => {
  const navigate = useNavigate();

  const suppliers = useSelector((state) => state.staff.suppliers.Societe);

  const [onAddPack, setOnAddPack] = useState(false);

  const [bdcReference, setBdcReference] = useState("");
  const [factureReference, setFactureReference] = useState("");
  const [factureRef, setFactureRef] = useState("");
  const [supplierId, setSupplierId] = useState(0);
  const [productId, setProductId] = useState(0);
  const [quantity, setQuantity] = useState(1);
  const [tva, setTva] = useState(0);
  const [promotion, setPromotion] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [unitPrice, setUnitPrice] = useState(0);
  const [productTableData, setProductTableData] = useState([]);
  const [lineNote, setLineNote] = useState("");
  const [documentLanguage, setDocumentLanguage] = useState("fr");
  const [productMapById, setProductMapById] = useState([]);
  const [promotionType, setPromotionType] = useState("pourcentage");
  const [discountType, setDiscountType] = useState("pourcentage");
  const [facturePriceTt, setFacturePriceTt] = useState(0);
  const [facturePriceHt, setFacturePriceHt] = useState(0);
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successAlertText, setSuccessAlertText] = useState();
  const [
    facturePricePurchasingWithoutDiscount,
    setFacturePricePurchasingWithoutDiscount,
  ] = useState(0);
  const [
    facturePricePurchasingWithDiscount,
    setFacturePricePurchasingWithDiscount,
  ] = useState(0);
  const [ordreTitle, setOrdreTitle] = useState("");
  const [ordreDateLimite, setOrdreDateLimite] = useState("any");
  const [ordreUrl, setOrdreUrl] = useState("any");
  const [bdcUrl, setBDCUrl] = useState("any");
  const [factureImageFile, setFactureImageFile] = useState([]);
  const [ordreDesignation, setOrdreDesignation] = useState("");

  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();

  const [openInfoAlert, setOpenInfoAlert] = useState(false);

  const [infoAlertText, setInfoAlertText] = useState();
  const animatedComponents = makeAnimated();
  const classes = useStyles();
  const [selectedOption, setSelectedOption] = useState(null);
  const [supplierSelectedOption, setSupplierSelectedOption] = useState(null);
  const [allProducts, setAllProducts] = React.useState([{}]);
  const [allSuppliers, setAllSuppliers] = React.useState([{}]);
  const [activeStep, setActiveStep] = React.useState(0);
  const [supplierSelectPlaceHolder, setSupplierSelectPlaceHolder] =
    useState("Choisir...");
  const [selected, setSelected] = useState([]);

  const [createFactureFromBDC, setCreateFactureFromBDC] = useState(false);
  const [productSelectPlaceHolder, setProductSelectPlaceHolder] =
    useState("Choisir...");

  const [availableFactureSelectedOption, setAvailableFactureSelectedOption] =
    useState(null);
  const [allAvailableFacture, setAllAvailableFacture] = React.useState([{}]);
  const [
    availableFactureSelectPlaceHolder,
    setAvailableFactureSelectPlaceHolder,
  ] = useState("Choisir...");

  const [
    availableBDCNotRelatedToFactureSelectedOption,
    setAvailableBDCNotRelatedToFactureSelectedOption,
  ] = useState(null);
  const [
    allAvailableBDCNotRelatedToFacture,
    setAllAvailableBDCNotRelatedToFacture,
  ] = React.useState([{}]);
  const [
    availableBDCNotRelatedToFactureSelectPlaceHolder,
    setAvailableBDCNotRelatedToFactureSelectPlaceHolder,
  ] = useState("Choisir...");

  //lot
  const [selectedOptionLot, setSelectedOptionLot] = useState(null);
  const [idLot, setIdLot] = useState(0);
  const [lotSelectPlaceHolder, setLotSelectPlaceHolder] =
    useState("Choisir...");
  const [allLot, setAllLot] = useState([]);
  const [availableLot, setAvailableLot] = useState([]);
  //devise

  const [selectedOptionMode, setSelectedOptionMode] = useState(null);
  const [modeProduct, setModeProduct] = useState(null);

  const [allCurrencies, setAllCurrencies] = React.useState([
    { value: "EUR", label: "Euro" },
    { value: "USD", label: "US Dollar" },
    { value: "AED", label: "United Arab Emirates Dirham" },
    { value: "CAD", label: "Canadian Dollar" },
    { value: "CNY", label: "Chinese Yuan" },
  ]);
  const [deviseChoosen, setDeviseChoosen] = useState(null);
  const [montantDevis, setMontantDevis] = useState(0);
  const [tauxChange, setTauxChange] = useState(0);
  const [labelDevise, setLabelDevise] = useState("Prix en DNT");
  const [selectedOptionDevis, setSelectedOptionDevis] = useState(null);
  const [deviseSelectPlaceHolder, setDeviseSelectPlaceHolder] =
    useState("Choisir...");
  const [modeProductSelectPlaceHolder, setModeProductSelectPlaceHolder] =
    useState("Choisir...");

  const [promotionPercentage, setPromotionPercentage] = useState(0);
  const [initialPriceHTC, setInitialPriceHTC] = useState(0);
  const [buyingPrice, setBuyingPrice] = useState(0);
  const [priceTT, setPriceTT] = useState(0);
  const [discountFinal, setDiscountFinal] = useState(0);

  const [availableRates, setAvailableRates] = useState([]);
  const [allRates, setAllRates] = useState([]);
  const [selectedRef, setSelectedRef] = useState([]);


  const [rateSelectPlaceHolder, setRateSelectPlaceHolder] =
    useState("Choisir une taxe");
  const [rateChoosen, setRateChoosen] = useState(null);
  const [rateName, setRateName] = useState("");
  const [rateCode, setRateCode] = useState("");
  const [rateType, setRateType] = useState("");
  const [rateTypeTax, setRateTypeTax] = useState("");
  const [rateTypeTVA, setRateTypeTVA] = useState("");

  const [valueRate, setValueRate] = useState();
  const [refBill, setRefBill] = useState("");

  const [rateTableData, setRateTableData] = useState([]);
  const [selectedOptionRate, setSelectedOptionRate] = useState(null);
  const steps = getSteps();
  const savingRef = useSaveRef(false);
  const printAfterSaveRef = useSaveRef(false);
  const [saving, setSaving] = useState(false);
  const [showQuickClient, setShowQuickClient] = useState(false);
  // a client created from the form is added to the list and selected right away
  const onClientCreated = (societe) => {
    const option = { value: societe.id, label: societe.title };
    setAllClients((old) => [...old, option]);
    onChangeSelectedSupplier(option);
  };
  const autoRunRef = useSaveRef(false);
  // live totals: same computation the wizard used to run when leaving the products step
  useEffect(() => {
      let result = UtilsFormule.CalculateNewPurchasingPriceAfterDiscount(
        productTableData,
        discount,
        discountType
      );
      // let sumTt = result[0];
      console.log("result discount handleNext", result);

      let sumPromotionHt = result[1];
      let sumPromotionTt = result[2];
      let sumPriceHt = result[3];

      setFacturePriceHt(sumPromotionHt);
      setFacturePriceTt(sumPromotionTt);
      setInitialPriceHTC(sumPriceHt);
      setBuyingPrice(sumPromotionHt);
      setPriceTT(sumPromotionTt);
      setDiscountFinal(result[4]);
  }, [productTableData, discount, discountType]);
  // single page: "Enregistrer" runs the former wizard steps (checks, totals, save) in a row
  const handleSave = () => {
    autoRunRef.current = true;
    handleNext();
  };
  useEffect(() => {
    if (activeStep > 2) {
      autoRunRef.current = false;
    } else if (autoRunRef.current && activeStep >= 1) {
      handleNext();
    }
  }, [activeStep]);
  const [allWarehouseSource, setAllWarehouseSource] = React.useState([{}]);
  const [warehousesSource, setWarehousesSource] = useState([]);
  const [warehouseSourceId, setWarehouseSourceId] = useState(0);
  const [warehouseSelectPlaceHolder, setWarehouseSelectPlaceHolder] =
    useState("Choisir...");
  const [estimUnitPrice, setEstimUnitPrice] = useState("");
  const [estimQte, setEstimQte] = useState("");
  const [estimTva, setEstimTva] = useState("");
  const [estimDevise, setEstimDevise] = useState("");

  const [productBloc, setProductBloc] = useState(false);
  const [clients, setClients] = useState([]);
  const [allClients, setAllClients] = useState([]);
  const [timbre, setTimbre] = useState(0);
  const [onGetStockProduct, setOnGetStockProduct] = useState(false);
  const [nameProductStock, setNameProductStock] = useState();
  const [productIdStock, setProductIdStock] = useState();
  const [seuil, setSeuil] = useState();

  $(".custom-file-input").on("change", function () {
    var fileName = $(this).val().split("\\").pop();
    $(this).siblings(".custom-file-label").addClass("selected").html(fileName);
  });
  useEffect(() => {
    ManufacturingBatchService.getManufacturingBatchByIdUser(
      getCurrentUserId(),
      0
    ).then((response) => {
      setAvailableLot(response.data);
    });
    RateService.getAllRatesByIdUserAndIsDeletedAndTypeTax(
      getCurrentUserId(),
      0,
      1
    ).then((result) => {
      console.log("result", result.data["success"]);
      if (result.data["success"]) {
        setAvailableRates(result.data["success"]);
      } else {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur :erreur serveur ");
      }
    });
    WarehouseService.getAllRealWarehouse(getCurrentUserId(), 0)
      .then((response) => {
        console.log("response", response);
        if (response.data.success) {
          setWarehousesSource(response.data.success);
        } else {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : pas de dépôt");
        }
      })
      .catch((e) => {
        console.log("error in getAllRealWarehouse", e);
      });
    Societe.getSocietesClients("CLIENT", "CLIENT", 1, 0)
      .then((reponse) => {
        setClients(reponse.data["Societe"]);
      })
      .catch((e) => {
        setOpenErrorAlert(true);
        setErrorAlertText(
          "Erreur : il ya un probléme pour obtenir les clients"
        );
      });
  }, []);

  useEffect(() => {
    warehousesSource &&
      warehousesSource.map((element) => {
        let exist = false;
        if (allWarehouseSource.length !== 0) {
          for (let index = 0; index < allWarehouseSource.length; index++) {
            if (allWarehouseSource[index].value === element?.id) {
              exist = true;
              break;
            }
          }
        }
        if (element?.id !== undefined && exist === false) {
          setAllWarehouseSource((oldArray) => [
            ...oldArray,
            { value: element.id, label: element.name },
          ]);
        }
        //here
      });
  }, [warehousesSource]);
  useEffect(() => {
    clients &&
      clients.map((element, i) => {
        let exist = false;
        if (allClients.length !== 0) {
          for (let index = 0; index < allClients.length; index++) {
            if (allClients[index].value === element?.id) {
              exist = true;
              break;
            }
          }
        }

        if (element?.id !== undefined && exist === false) {
          setAllClients((oldArray) => [
            ...oldArray,
            { value: element.id, label: element.title, customElements: {
              seuil: element.seuil,
            } },
          ]);
        }
      });
  }, [clients]);
  useEffect(() => {
    setAllRates([]);

    availableRates &&
      availableRates.map((element, i) => {
        setAllRates((oldArray) => [
          ...oldArray,
          {
            value: element.id,
            label: element.name,
            customElements: {
              code: element.code,
              type: element.type,
              value: element.value,
              typeTVA: element.typeTVA,
              typeTax: element.typeTax,
            },
          },
        ]);
      });
  }, [availableRates]);
  useEffect(() => {
    availableLot &&
      availableLot.map((element) => {
        setAllLot((oldArray) => [
          ...oldArray,
          { value: element.id, label: element.serialNumber },
        ]);
      });
  }, [availableLot]);

  useEffect(() => {
    suppliers &&
      suppliers.map((element, i) => {
        let exist = false;
        if (allSuppliers.length !== 0) {
          for (let index = 0; index < allSuppliers.length; index++) {
            if (allSuppliers[index].value === element?.id) {
              exist = true;
              break;
            }
          }
        }

        if (element?.id !== undefined && exist === false) {
          setAllSuppliers((oldArray) => [
            ...oldArray,
            { value: element.id, label: element.title },
          ]);
        }
      });
  }, [suppliers]);

  useEffect(() => {
    if (ordreDateLimite === ":59") {
      setOrdreDateLimite("any");
    }
  }, [ordreDateLimite]);

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };

  const onChangeQuantityHandler = (event) => {
    setQuantity(event.target.value);
  };

  const onChangeOrdreTitleHandler = (event) => {
    setOrdreTitle(event.target.value);
  };


  const onChangeOrdreDesignationHandler = (event) => {
    setOrdreDesignation(event.target.value);
  };


  const onChangeUnitPriceHandler = (event) => {
    setUnitPrice(event.target.value);
    setLabelDevise("Prix U en DNT");
    setMontantDevis(event.target.value);
  };

  const onChangeTvaHandler = (event) => {
    setTva(event.target.value);
  };


  const onChangeDiscountHandler = (event) => {
    setDiscount(event.target.value);
    CalculateNewPurchasingPriceAfterDiscount(event.target.value, discountType);
  };

  const onChangeDiscountTypeHandler = (event) => {
    setDiscountType(event.target.value);
    CalculateNewPurchasingPriceAfterDiscount(discount, event.target.value);
  };
  const CalculateNewPurchasingPriceAfterDiscount = (discount, discountType) => {
    if (discount !== 0) {
      if (discountType === "montant") {
        setFacturePricePurchasingWithDiscount(
          Math.round((facturePricePurchasingWithoutDiscount - discount) * 100) /
          100
        );
      } else {
        setFacturePricePurchasingWithDiscount(
          Math.round(
            (facturePricePurchasingWithoutDiscount -
              (facturePricePurchasingWithoutDiscount / 100) * discount) *
            100
          ) / 100
        );
      }
    } else {
      setFacturePricePurchasingWithDiscount(
        Math.round(facturePricePurchasingWithoutDiscount * 100) / 100
      );
    }
  };

  const onChangeBDCReferenceHandler = (selectedOptionn) => {
    setBdcReference(selectedOptionn.value);
    setAvailableBDCNotRelatedToFactureSelectedOption();

    setAvailableBDCNotRelatedToFactureSelectPlaceHolder(selectedOptionn.label);
  };

  const onChangeFactureReferenceHandler = (selectedOptionn) => {
    setFactureReference(selectedOptionn.value);
    setAvailableFactureSelectedOption();

    setAvailableFactureSelectPlaceHolder(selectedOptionn.label);
  };

  const onGetFactureByReference = () => {
    if (factureReference === "") {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : Aucune réference");
    } else {
      SellingService.getFactureByRef(factureReference, getCurrentUserId())
        .then((response) => {
          console.log("facture ref", response);
          if (Object.keys(response.data)[0] === "success") {
            setProductMapById([]);
            setProductTableData([]);
            response.data.success.sales.forEach((element) => {
              let lot = 0;
              if (element.manufacturingBatch != null) {
                lot = element.manufacturingBatch.id;
              }
              setProductMapById((previoustate) => [
                ...previoustate,
                {
                  productRef: element.product.name,
                  idProduct: element.product.id,
                  initialPriceHtc: element.initialPriceHtc,
                  quantity: element.quantity,
                  tva: element.tva,
                  sellingPrice: element.sellingPrice,
                  idLot: lot,
                  currency: element.currency,
                  currencyPrice: element.currencyPrice,
                  exchangeRate: element.exchangeRate,
                  isImport: element.isImport,
                  htPrice: Math.round(element.sellingPrice * element.quantity * 1000) /
                    1000,
                  ttPrice: Math.round(element.priceTt * element.quantity * 1000) /
                    1000,
                  promotionPercentage: element.promotionPercentage,
                  note: element.note,
                },
              ]);
              setProductTableData((previoustate) => [
                ...previoustate,
                {
                  productRef: element.product.name,
                  idProduct: element.product.id,
                  initialPriceHtc: element.initialPriceHtc,
                  quantity: element.quantity,
                  tva: element.tva,
                  currency: element.currency,
                  currencyPrice: element.currencyPrice,
                  exchangeRate: element.exchangeRate,
                  isImport: element.isImport,
                  sellingPrice: element.sellingPrice,
                  idLot: lot,
                  htPrice: Math.round(element.sellingPrice * element.quantity * 1000) /
                    1000,
                  ttPrice: Math.round(element.priceTt * element.quantity * 1000) /
                    1000,
                  promotionPercentage: element.promotionPercentage,
                  note: element.note,
                },
              ]);
            });
            if (response.data.ratePPResponse) {
              response.data.ratePPResponse.forEach((element) => {
                console.log("element", element);
                setRateTableData((previoustate) => [
                  ...previoustate,
                  {
                    idRate: element.idRate,
                    name: element.name,
                    value: element.value,
                    code: element.code,
                    type: element.type,
                    typeTax: element.typeTax,
                    typeTVA: element.typeTVA,
                    refBill: element.refBill,
                  },
                ]);
              });
            }
          } else if (Object.keys(response.data)[0] === "empty") {
            setOpenInfoAlert(true);
            setInfoAlertText("info : aucun facture  avec ce réference   ");
          }
        })
        .catch(() => {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : il ya un probléme de connexion");
        });
    }
  };
  const onGetBDCByReference = () => {
    if (bdcReference === "") {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : Aucune référence");
      setCreateFactureFromBDC(false);
      setProductMapById([]);
      setProductTableData([]);
    } else {
      if (selectedRef.includes(bdcReference)) {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : Cette référence est déjà ajoutée");
        return;
      }
  
      SellingService.getBDCByRef(bdcReference, getCurrentUserId())
        .then((response) => {
          if (Object.keys(response.data)[0] === "success") {
            if (response.data.success.state === 0) {
             
  
              response.data.success.sales.forEach((element) => {
                let lot = 0;
                if (element.manufacturingBatch != null) {
                  lot = element.manufacturingBatch.id;
                }
  
                const newProduct = {
                  productRef: element.product.name,
                  idProduct: element.product.id,
                  initialPriceHtc: element.initialPriceHtc,
                  quantity: element.quantity,
                  tva: element.tva,
                  sellingPrice: element.sellingPrice,
                  idLot: lot,
                  currency: element.currency,
                  currencyPrice: element.currencyPrice,
                  exchangeRate: element.exchangeRate,
                  isImport: element.isImport,
                  htPrice: Math.round(element.sellingPrice * element.quantity * 1000) / 1000,
                  ttPrice: Math.round(element.priceTt * element.quantity * 1000) / 1000,
                  promotionPercentage: element.promotionPercentage,
                  note: element.note,
                };
  
                const existingProductIndex = productMapById.findIndex(
                  (product) => product.idProduct === newProduct.idProduct
                );


              
                if (existingProductIndex !== -1) {
                  let productUpdateValue = productTableData[existingProductIndex];
                  productUpdateValue.quantity = productMapById[existingProductIndex].quantity + newProduct.quantity;;
  
                  let modelData = update(productTableData, {
                    [existingProductIndex]: { $merge: productUpdateValue },
                  });
          
                  let tableData = update(productMapById, {
                    [existingProductIndex]: { $merge: productUpdateValue },
                  });  
                
                  setProductMapById(tableData);
                  setProductTableData(modelData);
                } else {
                  // Add new product if it doesn't exist
                  productMapById.push(newProduct);
                  productTableData.push(newProduct);

                }

               
              });
            

              // Merge new products with existing products and sum quantities for duplicates
              // setProductMapById((previousState) => {
              //   const mergedProducts = [...previousState];
              //   console.log("Merged Products",mergedProducts)
              //   newProductMap.forEach((newProduct) => {
              //     console.log(newProduct)
              //     const existingProductIndex = mergedProducts.findIndex(
              //       (product) => product.idProduct === newProduct.idProduct
              //     );
  
              //     if (existingProductIndex !== -1) {
              //       // Update quantity for duplicate product by summing
              //       mergedProducts[existingProductIndex].quantity += newProduct.quantity;
              //     } else {
              //       // Add new product if it doesn't exist
              //       mergedProducts.push(newProduct);
              //     }
              //   });
  
              //   return mergedProducts;
              // });

  
              // setProductTableData((previousState) => {
              //   const mergedProducts = [...previousState];
              //   newProductTable.forEach((newProduct) => {
              //     const existingProductIndex = mergedProducts.findIndex(
              //       (product) => product.idProduct === newProduct.idProduct
              //     );
  
              //     if (existingProductIndex !== -1) {
              //       // Update quantity for duplicate product by summing
              //       mergedProducts[existingProductIndex].quantity += newProduct.quantity;
              //     } else {
              //       // Add new product if it doesn't exist
              //       mergedProducts.push(newProduct);
              //     }
              //   });
  
              //   return mergedProducts;
              // });
  
              if (response.data.success.ratePPs) {
                response.data.success.ratePPs.forEach((element) => {
                  setRateTableData((previousState) => [
                    ...previousState,
                    {
                      idRate: element.idRate,
                      name: element.name,
                      value: element.value,
                      code: element.code,
                      type: element.type,
                      typeTax: element.typeTax,
                      typeTVA: element.typeTVA,
                      refBill: element.refBill,
                    },
                  ]);
                });
              }
  
              setSelectedRef((previousState) => {
                const updatedState = [...previousState, bdcReference];
                setOrdreTitle(
                  `Facture sur les bons de commande : ${updatedState.join(", ")}`
                );
                setOrdreDesignation(
                  `Facture sur les bons de commande : ${updatedState.join(", ")}`
                );
                return updatedState;
              });
  
              setCreateFactureFromBDC(true);
              setDocumentLanguage((response.data.success && response.data.success.language) || "fr");
              setDiscountType("pourcentage");
              setDiscount(response.data.success.discountPercentage);
              setSupplierId(response.data.success.supplierId);
              setSupplierSelectPlaceHolder(response.data.success.clientTitle);
              setFacturePricePurchasingWithDiscount(
                response.data.success.sellingPrice
              );
            } else {
              setOpenInfoAlert(true);
              setInfoAlertText("Ce bon de commande est déjà confirmé");
            }
          } else if (Object.keys(response.data)[0] === "empty") {
            setOpenInfoAlert(true);
            setInfoAlertText("Info : Aucun bon de commande avec cette référence");
          }
        })
        .catch(() => {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : Il y a un problème de connexion");
        });
    }
  };
  
  
  
  // const onGetBDCByReference = () => {
  //   //here
  //   if (bdcReference === "") {
  //     setOpenErrorAlert(true);
  //     setErrorAlertText("Erreur : Aucune réference");
  //     setCreateFactureFromBDC(false);
  //     setProductMapById([]);
  //     setProductTableData([]);
  //   } else {
  //     SellingService.getBDCByRef(bdcReference, getCurrentUserId())
  //       .then((response) => {
  //         console.log("response", response);
  //         if (Object.keys(response.data)[0] === "success") {
  //           console.log("getBDCByRef", response);
  //           if (response.data.success.state === 0) {
  //             setProductMapById([]);
  //             setProductTableData([]);
  //             response.data.success.sales.forEach((element) => {
  //               let lot = 0;
  //               if (element.manufacturingBatch != null) {
  //                 lot = element.manufacturingBatch.id;
  //               }
  //               setProductMapById((previoustate) => [
  //                 ...previoustate,
  //                 {
  //                   productRef: element.product.name,
  //                   idProduct: element.product.id,
  //                   initialPriceHtc: element.initialPriceHtc,
  //                   quantity: element.quantity,
  //                   tva: element.tva,
  //                   sellingPrice: element.sellingPrice,
  //                   idLot: lot,
  //                   currency: element.currency,
  //                   currencyPrice: element.currencyPrice,
  //                   exchangeRate: element.exchangeRate,
  //                   isImport: element.isImport,
  //                   htPrice: Math.round(element.sellingPrice * element.quantity * 1000) /
  //                     1000,
  //                   ttPrice: Math.round(element.priceTt * element.quantity * 1000) /
  //                     1000,
  //                   promotionPercentage: element.promotionPercentage,
  //                 },
  //               ]);
  //               setProductTableData((previoustate) => [
  //                 ...previoustate,
  //                 {
  //                   productRef: element.product.name,
  //                   idProduct: element.product.id,
  //                   initialPriceHtc: element.initialPriceHtc,
  //                   quantity: element.quantity,
  //                   tva: element.tva,
  //                   currency: element.currency,
  //                   currencyPrice: element.currencyPrice,
  //                   exchangeRate: element.exchangeRate,
  //                   isImport: element.isImport,
  //                   sellingPrice: element.sellingPrice,
  //                   idLot: lot,
  //                   htPrice: Math.round(element.sellingPrice * element.quantity * 1000) /
  //                     1000,
  //                   ttPrice: Math.round(element.priceTt * element.quantity * 1000) /
  //                     1000,
  //                   promotionPercentage: element.promotionPercentage,
  //                 },
  //               ]);
  //             });

  //             if (response.data.success.ratePPs) {
  //               response.data.success.ratePPs.forEach((element) => {
  //                 console.log("element", element);
  //                 setRateTableData((previoustate) => [
  //                   ...previoustate,
  //                   {
  //                     idRate: element.idRate,
  //                     name: element.name,
  //                     value: element.value,
  //                     code: element.code,
  //                     type: element.type,
  //                     typeTax: element.typeTax,
  //                     typeTVA: element.typeTVA,
  //                     refBill: element.refBill,
  //                   },
  //                 ]);
  //               });
  //             }

  //             setCreateFactureFromBDC(true);
  //             setDiscountType("pourcentage");
  //             setDiscount(response.data.success.discountPercentage);
  //             setSupplierId(response.data.success.supplierId);
  //             setSupplierSelectPlaceHolder(response.data.success.clientTitle);
  //             setFacturePricePurchasingWithDiscount(
  //               response.data.success.sellingPrice
  //             );
  //           } else {
  //             setOpenInfoAlert(true);
  //             setInfoAlertText("ce bon de commande  est deja confirmé");
  //           }
  //         } else if (Object.keys(response.data)[0] === "empty") {
  //           setOpenInfoAlert(true);
  //           setInfoAlertText(
  //             "info : aucun bon de commande  avec ce réference "
  //           );
  //         }
  //       })
  //       .catch(() => {
  //         setOpenErrorAlert(true);
  //         setErrorAlertText("Erreur : il ya un probléme de connection");
  //       });
  //   }
  // };
  const onChangeSelected = (selectedOption) => {
    setSelectedOptionRate(selectedOption);
    setRateChoosen(selectedOption.value);
    setRateName(selectedOption.label);
    setRateCode(selectedOption.customElements.code);
    setRateType(selectedOption.customElements.type);
    setRateTypeTax(selectedOption.customElements.typeTax);
    setRateTypeTVA(selectedOption.customElements.typeTVA);
    setRateSelectPlaceHolder(selectedOption.label);
    setValueRate(selectedOption.customElements.value);
  };
  const handleNext = () => {
    if (activeStep === 0) {
      let result = UtilsFormule.CalculateNewPurchasingPriceAfterDiscount(
        productTableData,
        discount,
        discountType
      );
      // let sumTt = result[0];
      console.log("result discount handleNext", result);

      let sumPromotionHt = result[1];
      let sumPromotionTt = result[2];
      let sumPriceHt = result[3];

      setFacturePriceHt(sumPromotionHt);
      setFacturePriceTt(sumPromotionTt);
      setInitialPriceHTC(sumPriceHt);
      setBuyingPrice(sumPromotionHt);
      setPriceTT(sumPromotionTt);
      setDiscountFinal(result[4]);
    }
    if (activeStep === 0 && productBloc === false) {
      setOpenInfoAlert(true);
      setInfoAlertText(
        "Vous devez choisir un dépôt et appuyer sur le bouton flèche"
      );
    } else if (activeStep === 0 && productTableData.length > 0) {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    } else if (activeStep === 0 && productTableData.length === 0) {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : Aucun produit ");
    } else if (activeStep === 1 && ordreTitle === "") {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : Le champ de titre est vide ");
    } else if (activeStep === 1 && supplierId === 0) {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : aucun fournisseur ");
    } else if (activeStep === 1 && ordreDesignation === "") {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : aucun description ");
    }
    //  else if (activeStep === 1 && factureRef === "") {
    //   setOpenErrorAlert(true);
    //   setErrorAlertText("Erreur : aucun réference ");
    // }
    else if (activeStep === 1) {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
      setProductTableData(
        UtilsFormule.CalculateNewPurchasingDataTableAfterDiscount(
          productTableData,
          discountFinal
        )
      );
    } else if (activeStep === 2) {
      var factureModel = {};

      if (createFactureFromBDC === false) {
        factureModel = {
          buyingPrice: buyingPrice,
          description: ordreDesignation,
          discountPercentage: discountFinal,
          idClient: supplierId,
          refBdc: "any",
          refDBCs:selectedRef,
          idUser: getCurrentUserId(),
          initialPriceHtc: initialPriceHTC,
          note: ordreDesignation,
          path: "any",
          priceHT: facturePriceHt,
          priceTT: facturePriceTt,
          ref: factureRef,
          sales: productTableData,
          title: ordreTitle,
          language: documentLanguage,
          ratePPps: rateTableData,
          warehouseId: warehouseSourceId,
          timbre: timbre,
        };
      } else {
        factureModel = {
          description: ordreDesignation,
          ref: factureRef,
          refBdc: bdcReference,
          idUser: getCurrentUserId(),
          note: ordreDesignation,
          path: "any",
          refDBCs:selectedRef,
          title: ordreTitle,
          language: documentLanguage,
          ratePPps: rateTableData,
          warehouseId: warehouseSourceId,
          timbre: timbre,
          buyingPrice: buyingPrice,
          discountPercentage: discountFinal,
          idClient: supplierId,
          initialPriceHtc: initialPriceHTC,
          priceHT: facturePriceHt,
          priceTT: facturePriceTt,
          sales: productTableData,
        };
      }
      onSendFactureToBackendSystem(factureModel);
    }
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    PurchaseService.getAllFactureNotArchived()
      .then((response) => {
        if (Object.keys(response.data)[0] === "empty") {
          setAvailableFactureSelectPlaceHolder("Vide");
        } else if (Object.keys(response.data)[0] === "success") {
          let backendData = [{}];
          response.data.success.map((element) => {
            let elem = { value: element, label: element };
            backendData.push(elem);
          });
          setAllAvailableFacture(backendData);
          setAvailableFactureSelectPlaceHolder("Choisir...");
        }
      })
      .catch(() => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : il ya un probléme de connection");
      });

    PurchaseService.getAllBDCNotRelatedToFactureAndNotArchived()
      .then((response) => {
        if (Object.keys(response.data)[0] === "empty") {
          setAvailableBDCNotRelatedToFactureSelectPlaceHolder("Vide");
        } else if (Object.keys(response.data)[0] === "success") {
          let backendData = [{}];
          response.data.success.map((element) => {
            let elem = { value: element, label: element };
            backendData.push(elem);
          });
          setAllAvailableBDCNotRelatedToFacture(backendData);
          setAvailableBDCNotRelatedToFactureSelectPlaceHolder("Choisir...");
        }
      })
      .catch(() => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : il ya un probléme de connection");
      });
    setCreateFactureFromBDC(false);
    setProductMapById([]);
    setProductTableData([]);
    setUnitPrice(0);
    setQuantity(1);
    setTva(0);
    setPromotion(0);
    setActiveStep(0);
  };

  const onChangeSelectedProduct = (selectedOptionn) => {
    console.log("selectedOptionn", selectedOptionn);
    setSelectedOption();
    setProductId(selectedOptionn.value);
    setProductSelectPlaceHolder(selectedOptionn.label);
    setEstimUnitPrice(selectedOptionn.customElements.price);
    setEstimQte(selectedOptionn.customElements.quantity);
    setEstimTva(selectedOptionn.customElements.tva);
    setEstimDevise(selectedOptionn.customElements.devise);
    setUnitPrice(selectedOptionn.customElements.price);
    setMontantDevis(selectedOptionn.customElements.price);
    setTva(selectedOptionn.customElements.tva);
  };
  const onChangeSelectedSupplier = (selectedOptionn) => {
    setSelectedOption();
    setSupplierId(selectedOptionn.value);
    setSupplierSelectPlaceHolder(selectedOptionn.label);
  };

  const onSendFactureToBackendSystem = (factureModel) => {
    if (savingRef.current) {
      return;
    }
    savingRef.current = true;
    setSaving(true);
    console.log("factureModel", factureModel);
    SellingService.addFacture(factureModel)
      .then((response) => {
        if (Object.keys(response.data)[0] === "Facture") {
          setActiveStep((prevActiveStep) => prevActiveStep + 1);
          setOpenSuccessAlert(true);
          setSuccessAlertText("Enregistrement avec succées");
          setTimeout(() => {
            if (printAfterSaveRef.current) {
              sessionStorage.setItem("refDocument", response.data.Facture.ref);
              sessionStorage.setItem("typeDocument", "facture");
              navigate("/getDocumentSalesByRef?print=1");
            } else {
              navigate(`/allFactureSell`);
            }
          }, 2000);
        } else {
          savingRef.current = false;
          setSaving(false);
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : il ya un erreur  ");
        }
      })
      .catch(() => {
        savingRef.current = false;
          setSaving(false);
          setOpenErrorAlert(true);
        setErrorAlertText("Erreur : il ya un probléme de connection");
      });
  };
  const onChangeSelectedLot = (selectedOptionn) => {
    setSelectedOptionLot();
    setIdLot(selectedOptionn.value);
    setLotSelectPlaceHolder(selectedOptionn.label);
  };
  const getCurrencyRate = (deviseChoosen) => {
    try {
      CurrencyService.getTauxChage(deviseChoosen).then((response) => {
        console.log("response");
        setTauxChange(response.data);

        setLabelDevise(
          "TAUX D'ECH (" +
          response.data.toLocaleString(undefined, {
            maximumFractionDigits: 3,
          }) +
          ") ESTI DNT (" +
          (unitPrice * response.data).toLocaleString(undefined, {
            maximumFractionDigits: 3,
          }) +
          " )"
        );
      });
    } catch (error) {
      console.log("error currency", error);
    }
  };
  const onHandleClickTauxChange = () => {
    if (deviseChoosen !== null) {
      getCurrencyRate(deviseChoosen);
    }
  };
  const onChangeMontantDevisHandler = (event) => {
    setMontantDevis(0);
    setMontantDevis(event.target.value);
  };
  const labelDeviseTest = () => {
    return labelDevise;
  };
  const calculDevis = () => {
    return (
      <div className="col-sm-6">
        <div className="input-group">
          <label>{labelDeviseTest()}</label>
          <div className="input-group-prepend" style={{ width: "89%" }}>
            <input
              onChange={onChangeMontantDevisHandler}
              type="number"
              min="0"
              id="montantDevise"
              className="form-control"
            />
          </div>
          <div className=" input-group-append">
            <button
              onClick={onHandleClickTauxChange}
              type="button"
              class="btn btn-dark"
            >
              {" "}
              <i class="fas fa-solid fa-dollar-sign"></i>{" "}
            </button>
          </div>
        </div>
      </div>
    );
  };
  const onChangeSelectedDevis = (selectedOptionn) => {
    setSelectedOptionDevis(selectedOptionn.value);
    setDeviseChoosen(selectedOptionn.value);
    // setProductId(selectedOptionn.value);
    setDeviseSelectPlaceHolder(selectedOptionn.label);
  };
  const devise = () => {
    if (modeProduct === 2) {
      return (
        <div className="col-sm-8">
          <div className="row">
            <div className="col-sm-6">
              <div className="form-group">
                <label>Devise</label>
                <Select
                  closeMenuOnSelect={true}
                  components={animatedComponents}
                  defaultValue={selectedOptionDevis}
                  onChange={onChangeSelectedDevis}
                  options={allCurrencies}
                  placeholder={deviseSelectPlaceHolder}
                />
              </div>
            </div>
            {calculDevis()}
          </div>
        </div>
      );
    }
  };
  const columns = [
    {
      dataField: "productRef",
      text: "Libellé",
      headerAlign: "center",
    },
    {
      dataField: "initialPriceHtc",
      text: "Prix.U.HT",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "12%" };
      },
    },
    {
      dataField: "tva",
      text: "TVA",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "6%" };
      },
    },
    {
      dataField: "sellingPrice",
      text: "Prix U.V.TT",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "12%" };
      },
    },
    {
      dataField: "quantity",
      text: "Qte",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "6%" };
      },
    },

    {
      dataField: "htPrice",
      text: "Montant.HT",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "12%" };
      },
    },
    {
      dataField: "ttPrice",
      text: "Montant.TT",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "12%" };
      },
    },
    // {
    //   dataField: "promotionPercentage",
    //   text: "Remise",
    //   align: "center",
    //   headerAlign: "center",
    //   headerStyle: () => {
    //     return { width: "8%" };
    //   },
    // },
    {
      dataField: "note",
      text: "Note",
      headerAlign: "center",
      formatter: (cell) => cell || "",
    },
    {
      dataField: "idProduct",
      text: "Stock",
      headerStyle: () => {
        return { width: "10%" };
      },
      formatter: (cell, row, rowIndex, extraData) => (
        <span>
          <button
            style={{ width: 40 }}
            class="btn bg-gray btn-sm "
            data-toggle="modal"
            data-target="#edit-brand"
          >
            <i class="fas fa-eye"></i>
          </button>
        </span>
      ),
      events: {
        onClick: (e, column, columnIndex, row, rowIndex) => {
          console.log("productTableData", row);

          setProductIdStock(row.idProduct);
          setNameProductStock(row.productRef);
          setOnGetStockProduct(true);
        },
      },
    },
    {
      dataField: "idProduct",
      text: "SUP",
      headerStyle: () => {
        return { width: "10%" };
      },
      formatter: (cell, row, rowIndex, extraData) => (
        <span>
          <button className="btn btn-danger">
            <i class="fas fa-trash"></i>
          </button>
        </span>
      ),
      events: {
        onClick: (e, column, columnIndex, row, rowIndex) => {
          console.log("productTableData", productTableData);

          setProductTableData(
            productTableData.filter((item) => item.idProduct !== row.idProduct)
          );
        },
      },
    },
  ];

  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };
  function handleTableChange({ productTableData }) {
    return productTableData;
  }
  const onChangeValueRateHandler = (event) => {
    setValueRate(event.target.value);
  };
  const onChangeRefBillHandler = (event) => {
    setRefBill(event.target.value);
  };
  const blocRefFacture = () => {
    if (rateTypeTax === 2 && rateType === 1) {
      return (
        <div className="col-md-5">
          <label>Référence facture:</label>
          <input
            type="Ref"
            className="form-control"
            placeholder="Ajouter Référence"
            value={refBill}
            onChange={onChangeRefBillHandler}
          />
        </div>
      );
    } else {
      return <div className="col-md-5"></div>;
    }
  };

  const onAddTaxeToList = (event) => {
    if (rateChoosen === null) {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : Sélectionnez un taxe ");
    }
    if (valueRate == null) {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur :le valeur est vide ! ");
    } else {
      setRateTableData((previoustate) => [
        ...previoustate,
        {
          idRate: rateChoosen,
          name: rateName,
          value: valueRate,
          code: rateCode,
          type: rateType,
          typeTax: rateTypeTax,
          typeTVA: rateTypeTVA,
          refBill: refBill,
        },
      ]);
      setRefBill("");
      setRateChoosen(null);
      setRateSelectPlaceHolder("choisir une taxe");
      setRateName("");
      setRateCode("");
      setRateType("");
      setValueRate("");
    }
  };
  const blocRates = () => {
    if (rateChoosen !== null) {
      if (rateTypeTax === 1) {
        return (
          <>
            <div className="col-md-6">
              <label>Valeur:</label>
              <input
                onChange={onChangeValueRateHandler}
                type="number"
                value={valueRate}
                min="0"
                id="unitPrice"
                className="form-control"
                disabled
              />
            </div>
            {blocRefFacture()}
          </>
        );
      } else if (rateTypeTax === 2) {
        return (
          <>
            <div className="col-md-6">
              <label>Valeur:</label>
              <input
                onChange={onChangeValueRateHandler}
                type="number"
                value={valueRate}
                min="0"
                id="unitPrice"
                className="form-control"
              />
            </div>
            {blocRefFacture()}
          </>
        );
      }
    }
  };
  function buttonFormatter(cell, row) {
    if (row.typeTax === 1) {
      if (row.typeTVA === 1) {
        // return <span>Tax, avant TVA</span>;
        return <span>Tax, sur HTC</span>;
      } else if (row.typeTVA === 2) {
        // return <span>Tax, après TVA</span>;
        return <span>Tax, sur TTC</span>;
      }
    } else if (row.typeTax === 2) {
      if (row.type === 1) {
        return <span>Charge, avec facture</span>;
      } else if (row.type === 2) {
        return <span>Charge, sans facture</span>;
      }
    }
  }
  const columnsRate = [
    {
      dataField: "code",
      text: "Code",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "10%" };
      },
    },
    {
      dataField: "name",
      text: "Libellé",
      align: "center",
      headerAlign: "center",
    },
    {
      dataField: "typeTax",
      text: "Type",
      formatter: buttonFormatter,
      align: "center",
      headerAlign: "center",
    },
    {
      dataField: "value",
      text: "Valeur %",
      align: "center",
      headerAlign: "center",
    },
    {
      dataField: "idRate",
      text: "Supprimer",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "10%" };
      },
      formatter: (cell, row, rowIndex, extraData) => (
        <span>
          <button className="btn btn-danger">
            <i class="fas fa-trash"></i>
          </button>
        </span>
      ),
      events: {
        onClick: (e, column, columnIndex, row, rowIndex) => {
          console.log("rateTableData cell", rateTableData);

          setRateTableData(
            rateTableData.filter((item) => item.idRate !== row.idRate)
          );
        },
      },
    },
  ];
  function handleTableChangeRate({ rateTableData }) {
    return rateTableData;
  }
  const onChangeSelectedWarehouseSource = (selectedOptionn) => {
    setSelectedOption();
    setWarehouseSourceId(selectedOptionn.value);
    setWarehouseSelectPlaceHolder(selectedOptionn.label);
    // console.log("warehouseSourceID", selectedOptionn.value);
  };
  const getProdcutsAndBCAndFactureByWarehouse = (event) => {
    if (warehouseSourceId !== 0) {
      setProductBloc(true);
      startLoading();

      SellingService.getAllProductsOnSaleV2(
        getCurrentUserId(),
        1,
        warehouseSourceId
      )
        .then((response) => {
          if (response.data.success) {
            setAllProducts([{}]);
            response.data.success && setAllProducts(response.data.success);
          } else {
            setOpenErrorAlert(true);
            setErrorAlertText("Erreur : pas de dépôt");
          }
        })
        .catch(() => {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : il ya un probléme de connexion");
        });

      SellingService.getAllFactureNotArchived(
        getCurrentUserId(),
        warehouseSourceId
      )
        .then((response) => {
          if (Object.keys(response.data)[0] === "empty") {
            setAvailableFactureSelectPlaceHolder("Vide");
          } else if (Object.keys(response.data)[0] === "success") {
            let backendData = [{}];
            response.data.success.map((element) => {
              let elem = { value: element, label: element };
              backendData.push(elem);
            });
            setAllAvailableFacture(backendData);
            setAvailableFactureSelectPlaceHolder("Choisir...");
          }
        })
        .catch(() => {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : facture non archivées");
        })

      SellingService.getAllBDCNotRelatedToFactureAndNotArchived(
        getCurrentUserId(),
        warehouseSourceId
      )
        .then((response) => {
          if (Object.keys(response.data)[0] === "empty") {
            setAvailableBDCNotRelatedToFactureSelectPlaceHolder("Vide");
          } else if (Object.keys(response.data)[0] === "success") {
            let backendData = [{}];
            response.data.success.map((element) => {
              let elem = { value: element, label: element };
              backendData.push(elem);
            });
            setAllAvailableBDCNotRelatedToFacture(backendData);
            setAvailableBDCNotRelatedToFactureSelectPlaceHolder("Choisir...");
          }
        })
        .catch(() => {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : factures avec BC");
        }).finally(() => {
          stopLoading()
        });


    }
  };

  const handleOnSelect = (row, isSelect) => {

    console.log(row)

    if (isSelect) {
      setSelected([...selected, row.idProduct]);
    } else {
      setSelected(
        selected.filter(x => x !== row.idProduct)
      );
    }
    console.log("selected: " + selected)

  }
  const handleOnSelectAll = (isSelect, rows) => {
    console.log(rows)
    const ids = rows.map(r => r.idProduct);
    if (isSelect) {
      setSelected(ids);
    } else {
      setSelected([]);
    }
    console.log("selected: " + selected)

  }
  const selectRow = {
    mode: 'checkbox',
    clickToSelect: true,
    style: { backgroundColor: '#c8e6c9' },
    selected: selected,
    onSelect: handleOnSelect,
    onSelectAll: handleOnSelectAll,


  };
  function blocProducts() {
    if (productBloc && warehouseSourceId !== 0) {
      return (
        <div class="row">
          <div className="col-sm-12">
            <div className="form-group">
              <label>
                Vous pouvez choisir la référence d'un bon de commande pour la
                confirmer
              </label>
              <div className="input-group">
                <div className="input-group-prepend" style={{ width: "95%" }}>
                  <Select
                    styles={styles}
                    closeMenuOnSelect={true}
                    components={animatedComponents}
                    defaultValue={
                      availableBDCNotRelatedToFactureSelectPlaceHolder
                    }
                    onChange={onChangeBDCReferenceHandler}
                    options={allAvailableBDCNotRelatedToFacture}
                    placeholder={
                      availableBDCNotRelatedToFactureSelectPlaceHolder
                    }
                  />
                </div>
                <div className=" input-group-append">
                  <button
                    onClick={onGetBDCByReference}
                    type="button"
                    class="btn btn-dark"
                  >
                    <i class="fas  fa-solid fa-arrow-down"></i>
                  </button>
                </div>
              </div>
            </div>
            <div>
              <div class="row">
                <div className="col-sm-12">
                  <div className="form-group">
                    <label>
                      Vous pouvez entrer la référence d'un facture existant
                      pour obtenir ses produits
                    </label>
                    <div className="input-group">
                      <div
                        className="input-group-prepend"
                        style={{ width: "95%" }}
                      >
                        <Select
                          styles={styles}
                          closeMenuOnSelect={true}
                          components={animatedComponents}
                          defaultValue={availableFactureSelectedOption}
                          onChange={onChangeFactureReferenceHandler}
                          options={allAvailableFacture}
                          placeholder={availableFactureSelectPlaceHolder}
                        />
                      </div>
                      <div className=" input-group-append">
                        <button
                          onClick={onGetFactureByReference}
                          type="button"
                          class="btn btn-dark"
                        >
                          {" "}
                          <i class="fas  fa-solid fa-arrow-down"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div className="col-sm-12">
                  <div className="form-group">
                    <div>
                      <label>
                        Choisir un produit{" "}
                        <span style={{ color: "red" }}>*</span>
                      </label>

                      <Select
                        closeMenuOnSelect={true}
                        components={animatedComponents}
                        defaultValue={selectedOption}
                        onChange={onChangeSelectedProduct}
                        options={allProducts}
                        placeholder={productSelectPlaceHolder}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div className="col-sm-3">
                <div className="form-group">
                      <label htmlFor="inputClientCompany">
                        Prix.U.H.T ( {estimDevise})
                      </label>
                      <input
                        onChange={onChangeUnitPriceHandler}
                        value={unitPrice}
                        // disabled="true"
                        min="0"
                        id="unitPrice"
                        className="form-control"
                      />
                    </div>
                </div>
                <div className="col-sm-3">
                  <div className="form-group">
                    <label htmlFor="inputClientCompany">TVA</label>
                    <input
                      value={estimTva}
                      disabled="true"
                      onChange={onChangeTvaHandler}
                      min="0"
                      id="tva"
                      className="form-control"
                    />
                  </div>
                </div>
                <div className="col-sm-3">
                  <div className="form-group">
                    <label htmlFor="inputClientCompany">
                      Quantité
                      {/* <span style={{ color: "red" }}>*</span> (
                        {estimQte}) */}
                    </label>
                    <input
                      onChange={onChangeQuantityHandler}
                      value={quantity}
                      type="number"
                      min="0"
                      id="inputClientCompany"
                      className="form-control"
                    />
                  </div>
                </div>
                <div className="col-sm-3">
                  <div className="form-group">
                    <label>Choisir un Lot</label>

                    <Select
                      closeMenuOnSelect={true}
                      components={animatedComponents}
                      defaultValue={selectedOptionLot}
                      onChange={onChangeSelectedLot}
                      options={allLot}
                      placeholder={lotSelectPlaceHolder}
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-12">
                  <div className="form-group">
                    <label htmlFor="lineNote">Note du produit (facultatif)</label>
                    <textarea
                      id="lineNote"
                      rows={2}
                      maxLength={500}
                      value={lineNote}
                      onChange={(e) => setLineNote(e.target.value)}
                      className="form-control"
                      placeholder="Remarque propre à cette ligne (texte libre)"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div className="col-sm-6  text-center">
                  <button
                    style={{ marginBottom: 20 }}
                    className="btn btn-dark"
                    onClick={onAddProductToList}
                  >
                    <i class="fas fa-plus"></i>
                    Liste des ventes{" "}
                  </button>
                </div>
                <div className="col-sm-6  text-center">
                  <button
                    style={{ marginBottom: 20 }}
                    className="btn btn-dark"
                    data-toggle="modal"
                    data-target="#add-Pack"
                    onClick={onAddPackProductfromList}
                  >
                    <i class="fas fa-plus"></i>
                    Regrouper en pack{" "}
                  </button>
                </div>
              </div>
              <div class="row">
                <div className="col-sm-12">
                  <div className="form-group">
                    {productTableData && (
                      <ToolkitProvider
                        keyField="idProduct"
                        data={productTableData}
                        columns={columns}
                        onTableChange={handleTableChange}
                      >
                        {(props) => (
                          <div>
                            <div className="row">
                              <BootstrapTable
                                {...props.baseProps}
                                headerClasses="thead-light"
                                wrapperClasses="table-responsive w-100"
                                striped
                                hover
                                condensed
                                selectRow={selectRow}

                              />
                            </div>
                          </div>
                        )}
                      </ToolkitProvider>
                    )}
                  </div>
                </div>
              </div>
            </div>


          </div>
        </div>
      );
    }
  }
  const onChangeTimbreHandler = (event) => {
    setTimbre(event.target.value);
  };
  const blocButtonAddRates = () => {
    if (rateChoosen !== null) {
      return (
        <div className="row">
          <div className="col-md-8"></div>
          <div className="col-md-4">
            <button class="btn btn-dark  float-right" onClick={onAddTaxeToList}>
              <i class="fas fa-plus"></i>
              Ajouter taxe
            </button>
          </div>
        </div>
      );
    }
  };
  function getStepContent(step) {
    switch (step) {
      case 0:
        return (
          <div>
            {" "}
            <div class="row">
              <div className="col-sm-12">
                <div className="form-group">
                  <label>
                    Choisir le dépôt <span style={{ color: "red" }}>*</span>
                  </label>
                  <div className="input-group">
                    <div
                      className="input-group-prepend"
                      style={{ width: "95%" }}
                    >
                      <Select
                        styles={styles}
                        closeMenuOnSelect={true}
                        components={animatedComponents}
                        defaultValue={selectedOption}
                        onChange={onChangeSelectedWarehouseSource}
                        options={allWarehouseSource}
                        placeholder={warehouseSelectPlaceHolder}
                      />
                    </div>
                    <div className=" input-group-append">
                      <button
                        onClick={getProdcutsAndBCAndFactureByWarehouse}
                        type="button"
                        class="btn btn-dark"
                      >
                        <i class="fas  fa-solid fa-arrow-down"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* {getProdcutsAndDevisByWarehouse()} */}
            {blocProducts()}
          </div>
        );
      case 1:
        return (
          <div>
            <div className="card card-outline card-secondary mb-3">
              <div className="card-header py-2">
                <strong>
                  <i className="fas fa-user mr-2"></i>Client et facturation
                </strong>
              </div>
              <div className="card-body pb-1">
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="clientSelectFacture">
                        Client <span style={{ color: "red" }}>*</span>
                      </label>
                      <div className="d-flex align-items-start">
                        <div style={{ flex: 1 }}>
                          <Select
                            closeMenuOnSelect={true}
                            components={animatedComponents}
                            defaultValue={supplierSelectedOption}
                            onChange={onChangeSelectedSupplier}
                            options={allClients}
                            placeholder={supplierSelectPlaceHolder}
                          />
                        </div>
                        <button
                          type="button"
                          className="btn btn-outline-dark ml-2"
                          title="Ajouter un client"
                          onClick={() => setShowQuickClient(true)}
                        >
                          <i className="fas fa-user-plus"></i>
                        </button>
                      </div>
                      {showQuickClient && (
                        <QuickAddClient
                          onClose={() => setShowQuickClient(false)}
                          onCreated={onClientCreated}
                        />
                      )}
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group">
                      <label htmlFor="timbreFacture">
                        Timbre <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        value={timbre}
                        onChange={onChangeTimbreHandler}
                        type="number"
                        min="0"
                        id="timbreFacture"
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group">
                      <label>Type de remise</label>
                      <select
                        disabled={createFactureFromBDC}
                        value={discountType}
                        onChange={onChangeDiscountTypeHandler}
                        className="form-control select2"
                        style={{ width: "100%" }}
                      >
                        <option key={1} value={"pourcentage"}>
                          Pourcentage
                        </option>
                        <option key={2} value={"montant"}>
                          Montant
                        </option>
                      </select>
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group">
                      <label htmlFor="inputRemiseClientCompany">Remise</label>
                      <input
                        disabled={createFactureFromBDC}
                        value={discount}
                        onChange={onChangeDiscountHandler}
                        type="number"
                        min="0"
                        id="inputRemiseClientCompany"
                        className="form-control"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="card card-outline card-secondary mb-3">
              <div className="card-header py-2">
                <strong>
                  <i className="fas fa-align-left mr-2"></i>Description
                </strong>
              </div>
              <div className="card-body pb-1">
                <div className="form-group">
                  <label htmlFor="documentLanguage">Langue du document</label>
                  <select
                    id="documentLanguage"
                    className="form-control"
                    value={documentLanguage}
                    onChange={(e) => setDocumentLanguage(e.target.value)}
                    disabled={createFactureFromBDC}
                  >
                    <option value="fr">Français</option>
                    <option value="en">English</option>
                  </select>
                  <small className="text-muted">Le document généré (PDF) suit cette langue.</small>
                </div>
                <div className="form-group">
                  <label htmlFor="inputClientCompany">
                    Titre <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    value={ordreTitle}
                    required="required"
                    onChange={onChangeOrdreTitleHandler}
                    type="text"
                    id="inputClientCompany"
                    className="form-control"
                    placeholder="Ex : Facture de mars"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="inputDescription">
                    Note de la facture <span style={{ color: "red" }}>*</span>
                  </label>
                  <textarea
                    value={ordreDesignation}
                    placeholder="Informations à faire figurer sur la facture"
                    onChange={onChangeOrdreDesignationHandler}
                    id="inputDescription"
                    className="form-control"
                    rows={3}
                    required
                  />
                </div>
              </div>
            </div>

            <OptionalSection title="Fichier joint et taxes">
            <div class="row">
              <div className="col-sm-6">
                <div className="form-group">
                  <label>Choisir une taxe</label>
                  <Select
                    styles={styles}
                    closeMenuOnSelect={true}
                    components={animatedComponents}
                    defaultValue={selectedOptionRate}
                    onChange={onChangeSelected}
                    options={allRates}
                    placeholder={rateSelectPlaceHolder}
                  />
                </div>
              </div>
              {blocRates()}
            </div>
            {blocButtonAddRates()}

            <br />
            <div className="row">
              <div className="col-md-12">
                {rateTableData && (
                  <ToolkitProvider
                    keyField="rateTable"
                    data={rateTableData}
                    columns={columnsRate}
                    onTableChange={handleTableChangeRate}
                  >
                    {(props) => (
                      <div>
                        <div className="row">
                          <BootstrapTable
                            {...props.baseProps}
                            headerClasses="thead-light"
                            wrapperClasses="table-responsive w-100"
                            striped
                            hover
                            condensed
                          />
                        </div>
                      </div>
                    )}
                  </ToolkitProvider>
                )}
              </div>
            </div>
            </OptionalSection>
            <div className="card card-outline card-dark mb-0">
              <div className="card-body py-3">
                <div className="row text-center">
                  <div className="col-sm-3">
                    <small className="text-muted text-uppercase d-block">Total HT</small>
                    <strong style={{ fontSize: "1.3rem" }}>
                      {Number(facturePriceHt || 0).toLocaleString(undefined, { maximumFractionDigits: 3 })}
                    </strong>
                  </div>
                  <div className="col-sm-3">
                    <small className="text-muted text-uppercase d-block">TVA</small>
                    <strong style={{ fontSize: "1.3rem" }}>
                      {Number((facturePriceTt || 0) - (facturePriceHt || 0)).toLocaleString(undefined, { maximumFractionDigits: 3 })}
                    </strong>
                  </div>
                  <div className="col-sm-3">
                    <small className="text-muted text-uppercase d-block">Timbre</small>
                    <strong style={{ fontSize: "1.3rem" }}>
                      {Number(timbre || 0).toLocaleString(undefined, { maximumFractionDigits: 3 })}
                    </strong>
                  </div>
                  <div className="col-sm-3">
                    <small className="text-muted text-uppercase d-block">Total TTC</small>
                    <strong style={{ fontSize: "1.3rem" }}>
                      {(Number(facturePriceTt || 0) + Number(timbre || 0)).toLocaleString(undefined, { maximumFractionDigits: 3 })}
                    </strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      case 2:
        return (
          <div className="row">
            <span class="text-dark">
              Avant de cliquer sur terminé, vous devez être sûr des informations
              saisies
            </span>
          </div>
        );
      default:
        return "Unknown step";
    }
  }

  const onAddProductToList = (event) => {
    let productRef = null;
    let exist = false;
    let indexInDataTable;
    try {
      productMapById.forEach((element, index) => {
        if (element.idProduct === productId) {
          indexInDataTable = index;
          productRef = element.productRef;
          exist = true;
          console.log("productMapById indexInDataTable", indexInDataTable);
          throw "Break";
        }
      });
    } catch (e) {
      if (e !== "Break") throw e;
    }

    try {
      allProducts.forEach((element) => {
        if (element.value === productId) {
          productRef = element.customElements.name;
          throw "Break";
        }
      });
    } catch (e) {
      if (e !== "Break") throw e;
    }

    // else if (unitPrice === 0) {
    //   setOpenErrorAlert(true);
    //   setErrorAlertText("Le prix unitaire  doit être supérieur à 0");
    // } 
    // if (quantity === 0 || quantity < 0) {
    //   setOpenErrorAlert(true);
    //   setErrorAlertText("La quantité de  produit doit etre sup a zero ");
    // } else 
    if (productId === 0) {
      setOpenErrorAlert(true);
      setErrorAlertText("Sélectionnez un produit");
    } else {
      if (modeProduct === 0) {
      }
      let result = UtilsFormule.CalculatePromotionProductPurchase(
        promotionPercentage,
        promotionType,
        montantDevis,
        quantity,
        tva
      );
      let promotionAmountOrPersentage = result[0];
      let sellingPrice = result[1];
      let promotionpercent = result[2];
      let ttPrice = result[3];

      if (!exist) {
        setProductMapById((previoustate) => [
          ...previoustate,
          {
            productRef: productRef,
            idProduct: productId,
            initialPriceHtc: montantDevis,
            quantity: quantity,
            tva: tva,
            currency: deviseChoosen,
            currencyPrice: unitPrice,
            exchangeRate: tauxChange,
            isImport: modeProduct,
            sellingPrice: sellingPrice,
            idLot: idLot,
            htPrice: promotionAmountOrPersentage,
            ttPrice: Math.round((ttPrice * 1000) / 1000),
            promotionPercentage: promotionpercent,
            note: lineNote,
          },
        ]);
        setProductTableData((previoustate) => [
          ...previoustate,
          {
            productRef: productRef,
            idProduct: productId,
            initialPriceHtc: montantDevis,
            quantity: quantity,
            tva: tva,
            idLot: idLot,
            sellingPrice: sellingPrice,
            currency: deviseChoosen,
            currencyPrice: unitPrice,
            exchangeRate: tauxChange,
            isImport: modeProduct,
            htPrice: promotionAmountOrPersentage,
            ttPrice: Math.round((ttPrice * 1000) / 1000),
            promotionPercentage: promotionpercent,
            note: lineNote,
          },
        ]);
      } else if (exist) {
        let productUpdateValue = productTableData[indexInDataTable];
        productUpdateValue.promotionPercentage = promotionPercentage;
        productUpdateValue.initialPriceHtc = montantDevis;
        productUpdateValue.quantity = quantity;
        productUpdateValue.tva = tva;
        productUpdateValue.sellingPrice = sellingPrice;
        productUpdateValue.htPrice = promotionAmountOrPersentage;
        productUpdateValue.ttPrice = ttPrice;
        productUpdateValue.note = lineNote;

        let modelData = update(productTableData, {
          [indexInDataTable]: { $merge: productUpdateValue },
        });

        let tableData = update(productMapById, {
          [indexInDataTable]: { $merge: productUpdateValue },
        });
        if (productTableData[indexInDataTable].initialPriceHtc !== unitPrice) {
          setOpenInfoAlert(true);
          setInfoAlertText(
            "Info : Vous avez actualisé le produit :  " +
            productRef
          );
        } else if (
          productTableData[indexInDataTable].promotionType !== promotionType
        ) {
          setOpenInfoAlert(true);
          setInfoAlertText(
            "Info : Vous avez actualisé le produit :  " +
            productRef
          );
        } else if (
          productTableData[indexInDataTable].promotionPercentage !==
          promotionPercentage
        ) {
          setOpenInfoAlert(true);
          setInfoAlertText(
            "Info : Vous avez actualisé le produit : " + productRef
          );
        } else if (productTableData[indexInDataTable].quantity !== quantity) {
          setOpenInfoAlert(true);
          setInfoAlertText(
            "Info : Vous avez actualisé le produit : " + productRef
          );
        } else if (productTableData[indexInDataTable].tva !== tva) {
          setOpenInfoAlert(true);
          setInfoAlertText(
            "Info : Vous avez actualisé le produit : " + productRef
          );
        }

        setProductMapById(tableData);
        setProductTableData(modelData);
      }
    }
    etatInitial();
  };
  const onAddPackProductfromList = (event) => {
    setOnAddPack(true);
  }

  function etatInitial() {
    setLineNote("");
    setSelectedOption(null);
    setProductSelectPlaceHolder("Choisir...");
    setUnitPrice(0);
    setQuantity(1);
    setTva(0);
    setSelectedOptionMode(null);
    setPromotionType("pourcentage");
    setPromotionPercentage(0);
    setSelectedOptionLot(null);
    setLotSelectPlaceHolder("Choisir...");
  }

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <style>{`
        .quotation-form .form-group > label,
        .quotation-form .input-group > label {
          font-size: 0.8rem;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.03em;
          color: #6c757d;
        }
      `}</style>
      <section className="content-header">
        <div className="container-fluid">
          <div className="d-flex flex-wrap justify-content-between align-items-center">
            <div>
              <h4 className="mb-1">
                <i className="fas fa-file-alt mr-2"></i>Nouvelle facture de vente
              </h4>
              <small className="text-muted">
                Choisissez le dépôt et les produits ou les bons de commande, saisissez les informations
                du client puis validez la facture
              </small>
            </div>
            <button
              className="btn btn-outline-secondary mt-2 mt-sm-0"
              onClick={() => navigate("/allFactureSell")}
            >
              <i className="fas fa-arrow-left mr-1"></i>
              Retour aux factures
            </button>
          </div>
        </div>
      </section>
      <section className="content ">
        <div className="container-fluid">
          <div className="row mt-3">
            <div className="col-md-12">
              <div
                className="card card-outline card-dark quotation-form"
                style={{ borderRadius: 8, boxShadow: "0 1px 6px rgba(0,0,0,.08)" }}
              >
                
                {activeStep === steps.length ? (
                  <div>
                    <div className="card-body text-center py-5">
                      <i
                        className="fas fa-check-circle fa-3x mb-3 d-block"
                        style={{ color: "#28a745" }}
                      ></i>
                      <h5>Toutes les étapes ont été complétées avec succès</h5>
                    </div>
                    <div className="card-footer text-right">
                      <button className="btn btn-dark" onClick={handleReset}>
                        <i className="fas fa-undo mr-1"></i>
                        Nouvelle facture
                      </button>
                    </div>
                  </div>
                ) : (
                  <div>
                    <div className="card-body">{activeStep <= 2 ? (
                      <>
                        <h5 className="mb-3">
                          <i className="fas fa-boxes mr-2"></i>1. Produits
                        </h5>
                        {getStepContent(0)}
                        <hr />
                        <h5 className="mb-3">
                          <i className="fas fa-file-alt mr-2"></i>2. Informations du document
                        </h5>
                        {getStepContent(1)}
                      </>
                    ) : (
                      getStepContent(activeStep)
                    )}</div>
                    <div
                      className="card-footer d-flex justify-content-between align-items-center"
                      style={{ position: "sticky", bottom: 0, background: "#fff", zIndex: 5, boxShadow: "0 -2px 6px rgba(0,0,0,.06)" }}
                    >
                      <div>
                        <small className="text-muted d-block text-uppercase">
                          {productTableData.length} produit(s) · Total HT / TTC
                        </small>
                        <strong style={{ fontSize: "1.1rem" }}>
                          {Number(facturePriceHt || 0).toLocaleString(undefined, { maximumFractionDigits: 3 })} /{" "}
                          {Number((Number(facturePriceTt) + Number(timbre)) || 0).toLocaleString(undefined, { maximumFractionDigits: 3 })}
                        </strong>
                      </div>

                      <div>
                        {activeStep <= 2 && (
                          <button
                            type="button"
                            className="btn btn-outline-secondary mr-2"
                            onClick={() => navigate("/allFactureSell")}
                          >
                            Annuler
                          </button>
                        )}
                        {activeStep <= 2 && (
                          <button
                            type="button"
                            className="btn btn-outline-dark mr-2"
                            disabled={saving}
                            onClick={() => {
                              printAfterSaveRef.current = true;
                              handleSave();
                            }}
                          >
                            <i className="fas fa-print mr-1"></i>Enregistrer et imprimer
                          </button>
                        )}
                      <button className="btn btn-dark" disabled={saving} onClick={() => { if (activeStep <= 2) { printAfterSaveRef.current = false; handleSave(); } else { handleNext(); } }}>
                        {activeStep <= 2 ? (
                          <>
                            <i className="fas fa-save mr-1"></i>Enregistrer
                          </>
                        ) : activeStep === steps.length - 1 ? (
                          <>
                            <i className="fas fa-check mr-1"></i>Terminer
                          </>
                        ) : (
                          <>
                            Suivant<i className="fas fa-arrow-right ml-1"></i>
                          </>
                        )}
                      </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
      <Snackbar
        open={openSuccessAlert}
        autoHideDuration={2000}
        onClose={handleSuccessClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleSuccessClose} severity="success">
          {successAlertText}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openInfoAlert}
        autoHideDuration={4000}
        onClose={handleInfoClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleInfoClose} severity="info">
          {infoAlertText}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
      {onAddPack && <AddPackFactureModel selected={selected} setSelected={setSelected} setOnAddPack={setOnAddPack} listProducts={productTableData} idWarehouse={warehouseSourceId} idWarehousePrice={warehouseSourceId} setProductTableData={setProductTableData} />}


      {onGetStockProduct && (
        <StockOfProductSale
          setOnGetStockProduct={setOnGetStockProduct}
          idProduct={productIdStock}
          nameProduct={nameProductStock}
          idWarehouse={warehouseSourceId}
        />
      )}
    </div>
  );
};
export default withLoader(AddFactureSell);
